import {validateCreditCard} from '@ynap/credit-card-form'
import { validateKlarnaPhoneNumber } from './utils'

export default function validate(values, props) {
    const errors = {}
    const { messages } = props

    const cardError = validateCreditCard(values.creditCard, props)
    if (cardError && Object.entries(cardError).length > 0) {
        errors.creditCard = cardError
    }
    const billingAddress = values.billingAddress

    if ( values.paymentMethodId === 'KLARNA' &&
        billingAddress.hasOwnProperty('addressId') &&
        billingAddress.addressId !== "undefined" &&
        !billingAddress.transient &&  
        !validateKlarnaPhoneNumber(props?.savedAddresses, billingAddress)
        ) {
        errors.billingAddress = {
            addressId: billingAddress.addressId,
            isKlarna: values.paymentMethodId === 'KLARNA',
        }
    } else {
        errors.billingAddress = {
            isKlarna: false
        }
    }
    if (billingAddress && (!billingAddress.addressId || billingAddress.addressId == '')) {
        // By default addressId is 0 when creating new address
        if (Number.isNaN(billingAddress.addressId)) {
            // Redux form returns NaN for addressId when no radio button has been selected
            if (!errors.billingAddress) {
                errors.billingAddress = {}
            }
            errors.billingAddress.addressId = messages.paymentOptionsForm.errors.invalidAddress()
        } else if (props.formRef && props.formRef.current && props.formRef.current.hasErrors()) {
            errors.billingAddress = props.formRef.current.getErrors()
        }
    }

    return errors
}
